import { useDispatch } from 'react-redux';

import { setUser } from '../actions/userActions';
import { setNetworks } from '../actions/networksActions';
import { trackEvent } from '../helpers/analytics';
import { useSignInMutation } from '../services/user';
import { setupUserSession } from '../services/auth';
import { useSocialAuth } from './useSocialAuth';

export const useSignIn = ({ isInvite = false } = { isInvite: false }) => {
  const [userSignIn, { isLoading }] = useSignInMutation();
  const dispatch = useDispatch();
  const handleSocialAuth = useSocialAuth(isInvite);

  const signIn = (values) =>
    userSignIn(values)
      .unwrap()
      .then((response) => {
        const { token, user } = response;

        handleSocialAuth(user);

        return setupUserSession(token, user);
      })
      .then((user) => {
        dispatch(setUser(user));
        dispatch(setNetworks(user));

        return user;
      })
      .catch((error) => {
        if (error?.status === 401) {
          trackEvent('log_in_invalid');
        }

        throw error;
      });

  return { signIn, isLoading };
};
